import "./uicore-expr-input-hint.moduleRenamed.css";

export const methodHintItem = "uicore-expr-input-hint-module__methodHintItem___Feii1";
export const dumbHintItem = "uicore-expr-input-hint-module__dumbHintItem___NIXLm";
export const descriptionAnchor = "uicore-expr-input-hint-module__descriptionAnchor___zc6e6";
export const descriptionWrapper = "uicore-expr-input-hint-module__descriptionWrapper___7uhn5";
export const descriptionMinimizeButton = "uicore-expr-input-hint-module__descriptionMinimizeButton___pqROe";
export const descriptionMinimizedPlaceholder = "uicore-expr-input-hint-module__descriptionMinimizedPlaceholder___OIQ8W";

export default {
  methodHintItem: "uicore-expr-input-hint-module__methodHintItem___Feii1",
  dumbHintItem: "uicore-expr-input-hint-module__dumbHintItem___NIXLm",
  descriptionAnchor: "uicore-expr-input-hint-module__descriptionAnchor___zc6e6",
  descriptionWrapper: "uicore-expr-input-hint-module__descriptionWrapper___7uhn5",
  descriptionMinimizeButton: "uicore-expr-input-hint-module__descriptionMinimizeButton___pqROe",
  descriptionMinimizedPlaceholder: "uicore-expr-input-hint-module__descriptionMinimizedPlaceholder___OIQ8W",
};